// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512160803/js/" + chunkId + "." + {"44":"3bd11d23","225":"f4de7c51","481":"7ac123b4","486":"c7f030ec","770":"975d5ebd"}[chunkId] + ".0.290736591199765.chunk.js";
};